var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77979 10.64V17.97C3.77979 19.11 4.69979 20.03 5.83979 20.03H18.1698C19.3098 20.03 20.2298 19.11 20.2298 17.97V10.8",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91991 8.80997C8.91991 10.15 7.53991 11.23 5.83991 11.23C5.23991 11.23 4.68991 11.1 4.21991 10.87C3.18991 10.37 2.67991 9.17997 2.91991 8.05997L3.49991 5.31997C3.65991 4.53997 4.51991 3.96997 5.52991 3.96997H18.4899C19.4899 3.96997 20.3499 4.53997 20.5199 5.31997L21.0999 8.02997C21.0999 8.03997 21.1099 8.04997 21.0999 8.04997C21.3499 9.16997 20.8399 10.36 19.7999 10.86C19.3299 11.09 18.7699 11.22 18.1799 11.22C16.4699 11.22 15.0999 10.14 15.0999 8.79997",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0799 8.81C15.0799 10.15 13.6999 11.23 11.9999 11.23C10.2899 11.23 8.91992 10.15 8.91992 8.81",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91992 8.80998V3.97998",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0801 8.80998V3.97998",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0499 15.91H9.93994V20.02H14.0499V15.91Z",
    stroke: "#1F76CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.41164b4eb48b7d720b85d9582eb883a3.svg";
export { ForwardRef as ReactComponent };